import React from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import ProfileFieldGrid from './ProfileFieldGrid'

const Contact = props => {
  const { authenticationStore } = props
  const { currentUser } = authenticationStore

  if (!currentUser) return null

  const fields = [
    { title: 'Quê quán', value: currentUser?.other?.hometown },
    { title: 'Số máy nội bộ', value: currentUser?.home_phone },
    { title: 'Nơi ở hiện nay', value: currentUser?.address },
    { title: 'Số CMTND', value: currentUser?.other?.c_id },
    {
      title: 'Nơi đăng ký HKTT',
      value: currentUser?.other?.registration_location,
    },
    { title: 'Ngày cấp', value: currentUser?.other?.license_date },
    { title: 'Điện thoại di động', value: currentUser?.phone },
    { title: 'Số sổ BHXH', value: currentUser?.other?.si_no },
  ]

  return <ProfileFieldGrid fields={fields} />
}

Contact.propTypes = {
  authenticationStore: PropTypes.shape({
    currentUser: PropTypes.shape({
      address: PropTypes.string,
      home_phone: PropTypes.string,
      phone: PropTypes.string,
      other: PropTypes.shape({
        hometown: PropTypes.string,
        c_id: PropTypes.string,
        registration_location: PropTypes.string,
        license_date: PropTypes.string,
        si_no: PropTypes.string,
      }),
    }),
  }),
}

export default inject('authenticationStore')(observer(Contact))
